import { Component, DestroyRef, inject, Inject, OnInit, signal, ViewEncapsulation } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { finalize, Observable, tap } from 'rxjs';
import { SystemInfo } from 'src/app/services/models/support.models';
import { AppContext } from '../../../app/context';
import { logger } from '../../../pbir/utils/logger';
import { SupportService } from '../../../services/support.service';
import { catchAppError } from '../../../shared/utils';

export interface SystemData {
  systemInfo: Observable<SystemInfo>;
}

const LOGGER = logger('SystemDialog');

@Component({
  templateUrl: './system.dialog.html',
  styleUrls: ['./system.dialog.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class SystemDialog implements OnInit {
  readonly destroyRef = inject(DestroyRef);
  readonly appContext = inject(AppContext);
  readonly supportService = inject(SupportService);

  readonly user = this.appContext.user;

  readonly systemInfo = signal<SystemInfo>(null);
  readonly error = signal(false);
  readonly loading = signal(false);

  constructor(
    public dialogRef: MatDialogRef<SystemDialog>,
    @Inject(MAT_DIALOG_DATA) public data: SystemData) {
      this.dialogRef.addPanelClass('settings-modal-dialog-panel');
  }

  ngOnInit(): void {
    this.loading.set(true);
    this.supportService.provideSystemInfo().pipe(
      takeUntilDestroyed(this.destroyRef),
      tap(x => this.systemInfo.set(x)),
      catchAppError(err => {
        this.error.set(true);
        LOGGER.error(err);
      }, { errorMessage: 'Failed to load system information' }),
      finalize(() => {
        this.loading.set(false);
      })
    ).subscribe();
  }  

  close(): void {
    this.dialogRef.close();
  }
}
